<!--
 * @Author: ‘巴博尔’ 2164119982@qq.com
 * @Date: 2023-11-10 10:08:49
 * @LastEditors: ‘巴博尔’ 2164119982@qq.com
 * @LastEditTime: 2023-11-10 10:28:37
 * @FilePath: \admin_pc\src\views\saleOrder\components\order.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-form ref="registerRef" :model="orderInfo" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="phoneNumber">
            <el-input style="width: 270px" v-model="orderInfo.phoneNumber" placeholder="" readonly=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员姓名:" prop="childrenName">
            <el-input v-model="orderInfo.childrenName" style="width: 270px" placeholder="" readonly=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="家长姓名:" prop="name">
            <el-input style="width: 270px" v-model="orderInfo.name" placeholder="" readonly=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别:" prop="gender">
            <el-select v-model="orderInfo.gender" placeholder="请选择" style="width: 270px" disabled>
              <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="选择卡:" prop="cardName">
            <el-select v-model="orderInfo.cardName" placeholder="请选择" style="width: 270px" disabled>
              <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期(天):" prop="days">
            <el-input-number disabled style="width: 270px" placeholder="" v-model="orderInfo.days" :min="0"
              :precision="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="价格:" prop="valueMoney">
            <el-input-number disabled style="width: 270px" placeholder="" v-model="orderInfo.valueMoney" :min="0"
              :precision="2"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="总课时:" prop="totalLesssonCount">
            <el-input readonly="" style="width: 270px" v-model="orderInfo.totalLesssonCount" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="赠送课时:" prop="totalGiveCount">
            <el-input-number disabled style="width: 270px" placeholder="" v-model="orderInfo.totalGiveCount" :min="0"
              :precision="2"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="优惠金额:" prop="givenPay">
            <el-input-number disabled style="width: 270px" placeholder="" v-model="orderInfo.givenPay" :min="0"
              :precision="2"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="礼品:" prop="phoneNumber">
            <el-input readonly="" style="width: 270px" v-model="orderInfo.phoneNumber" placeholder=""></el-input>
          </el-form-item></el-col>
        <el-col :span="12">
          <el-form-item label="实付金额:" prop="totalPay">
            <el-input-number disabled style="width: 270px" placeholder="" v-model="orderInfo.totalPay" :min="0"
              :precision="2"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="邀约人:" prop="inviteWorker">
            <el-select v-model="orderInfo.inviteWorker" placeholder="请选择" style="width: 270px">
              <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="渠道:">
            <el-select v-model="orderInfo.source" clearable placeholder="请选择" style="width: 270px">
              <el-option v-for="item in sourceOptions" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-for="(item, index) in marketOrderRecordDTOList" :key="index">
        <el-col :span="12">
          <el-form-item label="销售:">
            <el-select clearable placeholder="下拉选择" style="width: 270px" v-model="item.marketWorkersId">
              <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业绩分配:">
            <el-input-number v-model="item.markRatio" :min="0" placeholder="请输入业绩分配" :precision="1"></el-input-number>
            <span>%</span>
            <i class="el-icon-circle-plus" style="font-size: 20px; cursor: pointer"
              v-if="index == marketOrderRecordDTOList.length - 1" @click="clickAddItemDTO"></i>
            <i class="el-icon-remove" style="font-size: 20px; cursor: pointer" v-else @click="clickDelItemDTO(index)"></i>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="备注:">
          <el-input v-model="orderInfo.remark" type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" style="width: 740px"></el-input>
        </el-form-item>
        <el-form-item label="录音:">
          <div style="width: 740px;display: flex;">
          <soundRecording ref="soundRecord" @clickRecStop="clickRecStop" @clickRecClear="clickRecClear" />
          <div v-if="audio" style="margin-left: 20px;">
            <audio controls ref="audio" class="aud"  controlsList="nodownload noplaybackrate">
              <source :src="audio" />
            </audio>
          </div>
        </div>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <!-- v-if="isShowBtn" -->
      <el-button type="primary" @click="handleUpdate()">确认</el-button>
    </div>

    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<script>
import globaldata from "@/utils/globaldata";
import soundRecording from "@/components/soundRecording";
import { saleOrderDetail, updateSaleOrder } from "@/api/saleOrder";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
import commonUtils from "@/utils/commonUtils";
import messageUtils from "@/utils/messageUtils";

export default {
  components: { soundRecording, WorkerWord },
  props: {
    orderInfo: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      genderOptions: [
        {
          value: 0,
          label: "男",
        },
        {
          value: 1,
          label: "女",
        },
      ],
      sourceOptions: [
        { name: "自然到访(WI)" },
        { name: "电话咨询(CI)" },
        { name: "网络咨询(NI)" },
        { name: "Peferral转介绍" },
        { name: "PT带到访" },
        { name: "CO" },
        { name: "异业合作" },
      ],
      allWorker: [],
      marketOrderRecordDTOList: [],
      isShowBtn: true,
      rules: {},
      refreshWord: "",
      showWordDlg: false,
      wordType: "",
      tData: "",
      audio:''
    };
  },
  created() {
    this.initParam();
  },
  mounted() {
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);

    this.getDetail();
  },

  methods: {
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop()
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      } else {
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      }
    },
    clickRecClear() {
      this.audio = ''
    },
    async getDetail() {
      const response = await saleOrderDetail({
        cardId: this.orderInfo.id,
      });
      console.log(response.data, ";response");
      if (response.code == 20000) {
        if (response.data.length) {
          this.marketOrderRecordDTOList = response.data;
          this.isShowBtn = false

        } else {
          this.isShowBtn = true
          this.marketOrderRecordDTOList = [
            {
              marketWorkersId: "",
              markRatio: "",
              buyCardId: this.orderInfo.id,
            },
          ];
        }
      }
    },
    clickDelItemDTO(index) {
      this.$delete(this.marketOrderRecordDTOList, index);
    },
    // 初始化参数
    initParam() {
      this.$nextTick(() => {
        this.audio = this.orderInfo.recording
        this.$refs.soundRecord.audio = this.orderInfo.recording
        this.$refs.soundRecord.localUrl = this.orderInfo.recording
        return
        this.audio = this.childInfo.recording
        this.$refs.soundRecord.audio = this.childInfo.recording
        this.$refs.soundRecord.localUrl = this.childInfo.recording
        console.log(this.$refs, this.childInfo, 'this.$refs.soundRecord========')
      })
    },
    clickAddItemDTO() {
      let is_add = true;
      try {
        this.marketOrderRecordDTOList.forEach((item) => {
          if (!item.marketWorkersId || item.markRatio == NaN) {
            is_add = false;
            this.$message.warning("请先填写销售/业绩分配");
            throw new Error("Something bad happened");
          }
        });
      } catch (error) {
        if (error == "Something bad happened") {
          throw error;
        }
      }
      if (is_add) {
        this.marketOrderRecordDTOList.push({
          marketWorkersId: "",
          markRatio: "",
          buyCardId: this.orderInfo.id,
        });
      }
    },
    handleUpdate() {
      let self = this;
      if (
        self.marketOrderRecordDTOList &&
        self.marketOrderRecordDTOList.length
      ) {
        let sum = 0;
        let is_add = true;
        self.marketOrderRecordDTOList.forEach((item) => {
          sum += item.markRatio;
          if (!item.marketWorkersId || item.markRatio == NaN) {
            is_add = false;
          }
        });
        if (sum != 100) {
          self.$message.error("业务分配有误");
          return;
        }
        if (!is_add) {
          self.$message.error("请先填写销售/业绩分配");
          return;
        }
      }
      let param = {
        list: this.marketOrderRecordDTOList,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        audio:this.audio,
        buyCardId:this.orderInfo.id,
        inviteWorker:this.orderInfo.inviteWorker,
        source:this.orderInfo.source,
        remark:this.orderInfo.remark
      };
      this.doRefreshWord(true, 1, param);
      // this.$emit("handleUpdate");
    },
    handleWord(wordType, tData) {
      if (wordType == 1) {
        this.doBuyExpCard(tData);
      }
    },
    doBuyExpCard(param) {
      updateSaleOrder(param).then((response) => {
        this.closeWordDlg();
        if (response.code == 20000) {
          messageUtils.successMsg(this, response.message);
          this.isShowBtn = true
          this.$emit("handleUpdate");
        } else {
          messageUtils.errorMsg(this, response.message);
        }
        // let data = response.data;
        // if (commonUtils.isObjectNull(data)) {
        //   messageUtils.errorMsg(this, response.message);
        //   return;
        // }
        // messageUtils.successMsg(this, response.message);
        this.$emit("onBtnhandleUpdate");
      });
    },
    doRefreshWord(show, wordType, tData) {
      this.tData = tData;
      this.wordType = wordType;

      this.showWordDlg = show;
      this.refreshWord = new Date().getTime();
    },
    closeWordDlg() {
      this.wordTitle = "";
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },
    getStoreWorkersInfo(workers) {
      this.allWorker = workers;
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/saleOrder/components/order.vue